import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import SidebarProfile from "../../components/home/SidebarProfile/SidebarProfile";
import "./Home.css";
import Search from "../../components/Search/Search";
import ClassSchedule from "../../components/home/CardClass/CardClass";
import CardBlog from "../../components/home/CardBlog/CardBlog";
import ListStudents from "../../components/home/ListStudents/ListStudents";
import InfoBanner from "../../components/home/InfoBanner/InfoBanner";

function HomePage() {
    return (
        <div className="app-container">
            <Sidebar />
            <main className="main-content-home">
                <div className="search-container-home">
                    <Search />
                </div>
                <div className="informativo-container">
                    <InfoBanner />
                </div>
                <div className="card-schedule-container">
                    <ClassSchedule />
                </div>
                <div className="card-blog-container">
                    <CardBlog />
                </div>
                <div className="list-students-container">
                    <div className="list-students-container-header">
                        <h2 className="list-students-title">Seus alunos</h2>
                        <p className="list-students-subtitle">Lista completa</p>
                    </div>
                    <ListStudents />
                </div>
            </main >
            <SidebarProfile />
        </div >
    );
}

export default HomePage;